import React, { useState, useEffect, useRef, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import VisitorTracker from "./components/VisitorTracker";
import Sidebar from "./components/SideBar/Sidebar";
import MainContent from "./components/MainContent/MainContent";
import RightPanel from "./components/RightPanel/RightPanel";
import Preloader from "./components/Preloader/Preloader";
import ChatWidget from "./components/ChatWidget/ChatWidget";
import ExitIntentModal from "./components/ExitIntentModal/ExitIntentModal";

import Login from "./components/Dashboard/Login";
import AdminDashboard from "./components/Dashboard/AdminDashboard";

function PublicSite() {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [showMobileNav, setShowMobileNav] = useState(true);

  const lastScrollTopRef = useRef(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");

    if (ref) {
      localStorage.setItem("ambassador_ref", ref.toLowerCase());
    }
  }, []);

  const handleScroll = useCallback((e) => {
    const el = e.currentTarget;
    const currentScrollTop = el.scrollTop;
    const topThreshold = 100;

    if (currentScrollTop < topThreshold) {
      setIsScrolled(false);
      setShowMobileNav(true);
      lastScrollTopRef.current = currentScrollTop;
      return;
    }

    setIsScrolled(true);
    const lastTop = lastScrollTopRef.current;

    if (currentScrollTop > lastTop + 2) {
      setShowMobileNav(false);
    } else if (currentScrollTop < lastTop - 2) {
      setShowMobileNav(true);
    }

    lastScrollTopRef.current = currentScrollTop;
  }, []);

  return (
    <div className={`app-container ${isScrolled ? "scrolled-mode" : ""}`}>
      {isLoading && <Preloader />}
      <Sidebar
        isScrolled={isScrolled}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        showMobileNav={showMobileNav}
      />

      <MainContent
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onScroll={handleScroll}
        isScrolled={isScrolled}
      />

      {activeTab === "home" && (
        <div className={`right-panel-wrapper ${isScrolled ? "hidden" : ""}`}>
          <div className="right-panel-container">
            <RightPanel />
          </div>
        </div>
      )}
      <ChatWidget />
      <ExitIntentModal />
    </div>
  );
}

function App() {
  return (
    <Router>
      <VisitorTracker />
      <Routes>
        <Route path="/*" element={<PublicSite />} />
        <Route path="/admin" element={<Login />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}

export default App;
